module.exports = __webpack_public_path__ + "img/pag-next.2820499f.svg";